angular.module("mercury.directives", [
  "mercury.directives.bepozperiodselect",
  "mercury.directives.datatable",
  "mercury.directives.googlechart",
  "mercury.directives.inputautocomplete",
  "mercury.directives.inputdate",
  "mercury.directives.inputdatetime",
  "mercury.directives.inputleave",
  "mercury.directives.inputmoney",
  "mercury.directives.inputnumber",
  "mercury.directives.inputpayrate",
  "mercury.directives.breakdetails",
  "mercury.directives.inputpercent",
  "mercury.directives.focusonshow",
  "mercury.directives.inputtime",
  "mercury.directives.feedback",
  "mercury.directives.loader",
  "mercury.directives.notifications",
  "mercury.directives.pagetitle",
  "mercury.directives.permissionrequired",
  "mercury.directives.popoverhtml",
  "mercury.directives.reportdatepicker",
  "mercury.directives.reporttimelink",
  "mercury.directives.servervalidate",
  "mercury.directives.sidenav",
  "mercury.directives.sidenav-icon",
  "mercury.directives.tablearrownav",
  "mercury.directives.topbar",
  "mercury.directives.alert",
  "mercury.directives.headerbadge",
  "mercury.directives.stoppropogation",
  "mercury.directives.icon-ai-powered",
  "mercury.directives.icon-close",
  "mercury.directives.icon-company",
  "mercury.directives.icon-dashboard",
  "mercury.directives.icon-early-access",
  "mercury.directives.icon-external-link",
  "mercury.directives.icon-feature-update",
  "mercury.directives.icon-help",
  "mercury.directives.icon-info",
  "mercury.directives.icon-message",
  "mercury.directives.icon-new",
  "mercury.directives.icon-new-feature",
  "mercury.directives.icon-settings",
  "mercury.directives.icon-user",
  "mercury.directives.icon-warning",
  "mercury.directives.earlyaccessmessage",
  "mercury.directives.featureupdatemessage",
  "mercury.directives.infomessage",
  "mercury.directives.newfeaturemessage",
  "mercury.directives.warningmessage",
]);
